if (!customElements.get('signup-modal')) {
  customElements.define(
    'signup-modal',
    class SignupModal extends ModalDialog {
      constructor() {
        super();

        this.modalClose = this.querySelector('[js-modal="close"]');

        // Grab cookie values on mount

        // Shopify generated
        // This custom el
        const hasModalClosed = this.getCookie('signup-modal-closed');

        if (window.designMode.enabled !== 'true') {
          this.delay = parseInt(this.dataset.delay) || 9000;
          this.checkSubmission(
            hasModalClosed
          );
          this.addEventListeners();
        } else {
          this.addEventListeners();
        }

        this.forceOpen();
      }

      /**
       * Check if the form has been submitted
       * This is checking for the URL param ?customer_posted=true
       */
      checkSubmission(l, c) {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const customerPosted = urlParams.get('customer_posted');

        if (!customerPosted) {
          this.checkCookie(l, c);
          return;
        }

        if (customerPosted === 'true') {
          this.show();
          setCookie('signup-modal-closed', 'true', 340);
          this.successMessage();
        } else {
          this.checkCookie(l, c);
        }
      }

      /**
       * Check if the cookie has been set
       * If it hasn't been set, show the modal
       *
       * @param {String} l - Locale (Shopiy) - Shopify default predicted locale code
       * @param {String} c - Closed - Has the signup modal closed?
       */
      checkCookie() {
        if (this.getCookie('signup-modal-closed') == undefined) {
          setTimeout(() => {
            this.show();
          }, this.delay);
        }
      }

      successMessage() {
        const items = document.querySelectorAll('.js-sign-up-success');

        items.forEach((item) => {
          item.classList.add('is-hidden');
        });
      }

      hide() {
        super.hide();
        this.setCookie('signup-modal-closed', 'true', 30);
        this.videoStop();
      }

      show(opener) {
        super.show(opener);
        this.videoPlay();
      }

      videoPlay() {
        const video = this.querySelector('video');
        if (video) {
          video.play();
        }
      }

      videoStop() {
        const video = this.querySelector('video');
        if (video) {
          video.pause();
        }
      }

      /**
       * This is for the theme editor
       * This will display the modal when the user is editing the section
       */
      addEventListeners() {
        document.addEventListener('shopify:section:select', (event) => {
          this.hide();
          const id = event.detail.sectionId;
          if (id != 'sign-up-modal') {
            return;
          }
          const opener = `#SignupModal-${id} button`;
          this.show(opener);
        });

        document.addEventListener('shopify:section:deselect', (event) => {
          this.hide();
        });

        this.modalClose.addEventListener('click', () => {
          this.hide();
        });

        // on key escape close modal
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.hide();
          }
        });
      }

      forceOpen() {
        const urlParams = new URLSearchParams(window.location.search);
        const signup_modal = urlParams.get('signup_modal');
        const form_type = urlParams.get('form_type');

        // if url contains /challenge
        if (window.location.pathname.includes('/challenge')) {
          return;
        }

        if (signup_modal === 'true' || form_type === 'customer') {
          this.show();
        }
      }

      getCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

      setCookie(name, value, days) {
        let expires = '';
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
      }
    },
  );
}
